import { defineStore } from 'pinia';
import gettext from '@/i18n/gettext';

const useCommonStore = defineStore('common', {
  state: () => ({
    forceMainNavigationDrawer: false,
  }),
  getters: {
    language: () => gettext.current,
    humanReadableLanguage: () => gettext.available[gettext.current],
    environment: () => process.env.NODE_ENV,
  },
  actions: {
    toggleForceMainNavigationDrawer() {
      this.forceMainNavigationDrawer = !this.forceMainNavigationDrawer;
    },
  },
});

export default useCommonStore;
